import curry from 'lodash/curry';
import find from 'lodash/find';

const formatValue = curry((
  availableFilters: io.flow.v0.models.AvailableFilterStructured[],
  value: string,
) => find(availableFilters, { field: value }));

export default formatValue;
